export enum AUTH_ACTION {
  UNKNOWN = 0,

  ERROR = 1,
  REQUEST = 2,
  AUTH_SUCCESSFUL = 3,
  AUTH_UNSUCCESSFUL = 4,

  TOO_MANY_AUTH_ATTEMPTS = 100,
  INVALID_MESSAGE = 101,
  INVALID_MESSAGE_DATA = 102,
}
